module.exports = __webpack_public_path__ + "static/img/freezer_outdoor.318858b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_outdoor.jpg
// module id = BLbZ
// module chunks = 1